import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faPlusCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Subscription, forkJoin } from 'rxjs';
import { Alert } from 'src/app/classes/alert';
import { FilterCrest } from 'src/app/classes/filterCrest';
import { CrestService } from 'src/app/services/crest.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Pagination } from 'src/app/classes/pagination';


@Component({
    selector: 'app-crest-list',
    templateUrl: './crest-list.component.html',
    styleUrls: ['./crest-list.component.scss']
})
export class CrestListComponent implements OnInit{
    subscription: any;
    cols: string[];
    searchForm = this.fb.group({});
    pathList: Array<Array<string>>;
    unsubscribe$: Subscription;
    filterCrest: FilterCrest;
    busy: Subscription;
    listPagination: Pagination;
    list: any;
    maxSize = 15
    groupid_list: any;
    cresttype_id_list: any;
    faPlus = faPlusCircle;
    faTrash = faTrashAlt;
    Displayable = true
    type_id = 1
    @Input() routePart: string;
    constructor(private router: Router, public CrestService: CrestService, private fb: FormBuilder, private sanitizer: DomSanitizer){
        this.pathList = [['Stemmi', 'crest/list']];
    }
    getList(){
        let filter: Array<any> | null = null;
        if (this.searchForm.value){
            filter = [];
        }
        this.filterCrest = new FilterCrest();
        for (const key in this.searchForm.value) {
            if (Object.prototype.hasOwnProperty.call(this.searchForm.value, key)) {
                const element = this.searchForm.value[key];
                if ((element || element == '') && element != 'null') {
                    const itemKey = key.split('_')
                    itemKey.shift();
                    filter[itemKey.join('_')] = element;
                    this.filterCrest['ctrl_' + itemKey.join('_')] = element;
                }
            }
        }
        filter['limit'] = this.maxSize;
        if(!filter['page']){
            filter['page'] = 1
        }
        filter['cresttype_id'] = 1
        this.CrestService.setFilterObs(this.filterCrest);
        this.busy = this.CrestService.list2(filter).subscribe(crest => {
            try{
                this.list = crest
                this.listPagination = crest.payload
            } catch(error) {
                console.log(error)
            }
            this.list.payload = this.list.payload.map(item => {
                if (item.base64) {
                    const encoded = btoa(item.base64);
                    const fullDataUrl  = 'data:image/svg+xml;base64,' + encoded;
                    item.base64 = this.sanitizer.bypassSecurityTrustResourceUrl(fullDataUrl);
                }
                return item
            });
        })


    }
    
    deleteItem(id: number){
        if(+id > 0){
            this.busy = this.CrestService.delete(id).subscribe({
                next: () => this.getList(),
                error: (err) => console.log(err),
            });
        }
        
    }
    page_nr($event) {
        this.searchForm.controls['ctrl_page'].setValue($event);
        this.getList();
      }
    
      formControlsNames(form) {
        return Object.keys(form);
      }

    dialogConfirm(id) {
        if (+id > 0) {
          this.deleteItem(id);
        }
      }
    navigateTo(id: any) {
        this.router.navigate([`/crest/${id}`]);
    }
    ngOnInit(): void {
        this.cols = ["description", "group_id", "cresttype_id", "status"];
        this.searchForm.addControl('ctrl_page', new FormControl('', Validators.required))
        for (const col of this.cols){
            this.searchForm.addControl('ctrl_' + col, new FormControl('', Validators.required))
        }
        this.unsubscribe$ = this.CrestService.getFilterObs().subscribe(filter => {
            this.filterCrest = filter;
            this.searchForm.controls['ctrl_page'].setValue(this.filterCrest.ctrl_page);
            this.searchForm.controls['ctrl_description'].setValue(this.filterCrest.ctrl_description);
            //this.searchForm.controls['ctrl_group_id'].setValue(this.filterCrest.ctrl_group_id);
            //this.searchForm.controls['ctrl_cresttype_id'].setValue(this.filterCrest.ctrl_cresttype_id);

            this.searchForm.controls['ctrl_status'].setValue(this.filterCrest.ctrl_status);
        });
        this.busy = this.CrestService.crestFilters().subscribe(response => {
            try{
                this.cresttype_id_list = response.payload.crest_types;
                this.groupid_list = response.payload.group_ids;
            }catch(error){
                console.log(error)
            }

        })
        this.busy = this.CrestService.hasCrestListItems(this.type_id).subscribe({
            next: (data) => {
                if(data.payload === true){
                    this.getList();
                }
                this.Displayable = data.payload
                this.setDisable()
            },
            error: (err) => {
                console.log(err)
            }
        })
        
    }
    setDisable() {
        Object.keys(this.searchForm.value).forEach(key => { 
            const control = this.searchForm.get(key);
            if(!this.Displayable){
                control?.disable();
            } else{
                control?.enable();
            }
        })
    }
}